function Features() {
  return (
    <section id="features" className="py-16">
      <div className="container mx-auto px-4">
        {/* Section Title */}
        <h2 className="text-3xl font-bold text-center mb-12 text-gray-900">
          All Your Academics. One App.
        </h2>

        {/* Feature 1: Track Study Points */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-16">
          {/* Text */}
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Track Study Points
            </h3>
            <p className="text-lg text-gray-600">
              Our core system lets admins set weekly point goals. Members submit
              'Point Requests' for activities like good grades, tutoring, or study
              hours to get approved.
            </p>
          </div>

          {/* Image Placeholder */}
          <div className="rounded-lg shadow-lg h-80 flex items-center justify-center" style={{ background: 'linear-gradient(to bottom right, #fce7ed, #f8e8f3)' }}>
            <div className="text-gray-400 text-center">
              <svg
                className="w-24 h-24 mx-auto mb-4"
                fill="none"
                stroke="#a60533"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
              <p className="text-sm" style={{ color: '#a60533' }}>Study Points Dashboard</p>
            </div>
          </div>
        </div>

        {/* Feature 2: Integrations (Reversed) */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-16">
          {/* Image Placeholder */}
          <div className="rounded-lg shadow-lg h-80 flex items-center justify-center md:order-first order-last" style={{ background: 'linear-gradient(to bottom right, #e5f8f3, #e5f0ff)' }}>
            <div className="text-gray-400 text-center">
              <svg
                className="w-24 h-24 mx-auto mb-4"
                fill="none"
                stroke="#05a678"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
              <p className="text-sm" style={{ color: '#05a678' }}>Canvas & Location Integration</p>
            </div>
          </div>

          {/* Text */}
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Powerful Integrations
            </h3>
            <p className="text-lg text-gray-600">
              Connect directly to Canvas to easily attach assignments and grades.
              Automatically track 'Study Hours' by enabling location tracking for
              designated study areas on campus.
            </p>
          </div>
        </div>

        {/* App Gallery - Horizontal Scroll */}
        <div className="mt-16">
          <h3 className="text-2xl font-bold text-center mb-8 text-gray-900">
            See It In Action
          </h3>

          {/* Horizontal Scroll Container */}
          <div className="relative">
            <div className="flex overflow-x-auto space-x-4 p-4 pb-8">
              {/* Screenshot 1 */}
              <div className="min-w-[250px] h-[450px] rounded-lg shadow-md flex-shrink-0 flex items-center justify-center" style={{ background: 'linear-gradient(to bottom right, #fce7ed, #f8e8f3)' }}>
                <div className="text-center">
                  <svg
                    className="w-16 h-16 mx-auto mb-2"
                    fill="none"
                    stroke="#a60533"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                    />
                  </svg>
                  <p className="text-sm font-medium" style={{ color: '#a60533' }}>Home Screen</p>
                </div>
              </div>

              {/* Screenshot 2 */}
              <div className="min-w-[250px] h-[450px] rounded-lg shadow-md flex-shrink-0 flex items-center justify-center" style={{ background: 'linear-gradient(to bottom right, #e5f0ff, #e5f7ff)' }}>
                <div className="text-center">
                  <svg
                    className="w-16 h-16 mx-auto mb-2"
                    fill="none"
                    stroke="#007bff"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                    />
                  </svg>
                  <p className="text-sm font-medium" style={{ color: '#007bff' }}>Point Requests</p>
                </div>
              </div>

              {/* Screenshot 3 */}
              <div className="min-w-[250px] h-[450px] rounded-lg shadow-md flex-shrink-0 flex items-center justify-center" style={{ background: 'linear-gradient(to bottom right, #e5f8f3, #e8f9f5)' }}>
                <div className="text-center">
                  <svg
                    className="w-16 h-16 mx-auto mb-2"
                    fill="none"
                    stroke="#05a678"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    />
                  </svg>
                  <p className="text-sm font-medium" style={{ color: '#05a678' }}>Member Profile</p>
                </div>
              </div>

              {/* Screenshot 4 */}
              <div className="min-w-[250px] h-[450px] rounded-lg shadow-md flex-shrink-0 flex items-center justify-center" style={{ background: 'linear-gradient(to bottom right, #fce7ed, #f8e8f3)' }}>
                <div className="text-center">
                  <svg
                    className="w-16 h-16 mx-auto mb-2"
                    fill="none"
                    stroke="#a60533"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                    />
                  </svg>
                  <p className="text-sm font-medium" style={{ color: '#a60533' }}>Analytics</p>
                </div>
              </div>

              {/* Screenshot 5 */}
              <div className="min-w-[250px] h-[450px] rounded-lg shadow-md flex-shrink-0 flex items-center justify-center" style={{ background: 'linear-gradient(to bottom right, #e5f0ff, #e5f7ff)' }}>
                <div className="text-center">
                  <svg
                    className="w-16 h-16 mx-auto mb-2"
                    fill="none"
                    stroke="#007bff"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                  <p className="text-sm font-medium" style={{ color: '#007bff' }}>Settings</p>
                </div>
              </div>

              {/* Screenshot 6 */}
              <div className="min-w-[250px] h-[450px] rounded-lg shadow-md flex-shrink-0 flex items-center justify-center" style={{ background: 'linear-gradient(to bottom right, #e5f8f3, #e8f9f5)' }}>
                <div className="text-center">
                  <svg
                    className="w-16 h-16 mx-auto mb-2"
                    fill="none"
                    stroke="#05a678"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
                    />
                  </svg>
                  <p className="text-sm font-medium" style={{ color: '#05a678' }}>Admin Chat</p>
                </div>
              </div>
            </div>

            {/* Scroll Hint */}
            <div className="text-center mt-4">
              <p className="text-sm text-gray-500">← Scroll to see more →</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Features;

